import { Injectable } from '@angular/core';
import { LoggerService } from './logger.service';
import { Router } from '@angular/router';
import { InMemoryCacheService } from '../cache/in-memory-cache.service';
// import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
// import { NotificationComponent } from 'app/modals/notification/notification.component';

@Injectable({
    providedIn: 'root'
})
export class ErrorService {

    public errors: string[];

    constructor(private logger: LoggerService, private cache: InMemoryCacheService) {
        this.errors = [];
    }

    public addError(error: string, fatal = false) {
        this.errors.push(error);

        if (!fatal) {
            this.clearError();
        }
    }

    public handleError(response: any) {

        let message = '';
        this.errors.length = 0;

        if (response.error && response.error.message) {
            message = response.error.message;
        } else {
            message = response.statusText;
        }

        if (this.cache.showErrorModal) {
            // const modalRef = this.modalService.open(NotificationComponent);
            // modalRef.componentInstance.title = 'Error';
            // modalRef.componentInstance.showDenyBtn = true;
            // modalRef.componentInstance.denyBtnLabel = 'OK';
            // modalRef.componentInstance.message = message;
        } else {
            // this.toastr.error(message);
        }

        this.cache.showErrorModal = false;
        window.scrollTo(0, 0);
    }

    private clearError() {
        setTimeout(() => {
            this.errors.length = 0;
            this.logger.info('errors', this.errors);
        }, 20000);
    }

}
